import { useEffect, useState } from "react";
import { subscribeToGallery } from "../services/galleryService";

const GalleryPage = () => {
  const [images, setImages] = useState([]);

  useEffect(() => {
    const unsubscribe = subscribeToGallery((items) => {
      setImages(items.filter((item) => item.visible !== false));
    });
    return () => {
      if (unsubscribe) {
        unsubscribe();
      }
    };
  }, []);

  return (
    <section className="gallery-page">
      <header>
        <h2>चित्र दीर्घा</h2>
        <span className="caption">Image Gallery</span>
        <p>
          आर्य समाज के विविध आयामों को दर्शाने वाली झलकियां — समारोह, यज्ञ,
          संगोष्ठियाँ और समाज सेवा की अनुभूतियाँ।
        </p>
        <span className="caption">
          A glimpse of Arya Samaj&apos;s vibrant engagements — rituals,
          seminars, and community service moments.
        </span>
      </header>
      <div className="gallery-grid">
        {images.map((image) => (
          <figure key={image.id}>
            <img
              src={image.downloadUrl}
              alt={image.titleEnglish || "Gallery visual"}
              loading="lazy"
            />
            <figcaption>
              <span>{image.titleHindi}</span>
              <span className="caption">{image.titleEnglish}</span>
            </figcaption>
          </figure>
        ))}
        {images.length === 0 && <p>चित्रों का संग्रह अद्यतन किया जा रहा है।</p>}
      </div>
    </section>
  );
};

export default GalleryPage;
